import _ from 'lodash';
import { gEnums } from '../../../enums/globalEnums';
import { createPropsFromData, settingsHelpers } from '../../../viewSettings/helpers/settingsHelpers';

export const getProps_viewItem = (viewItem, viewListData, props_vig) => {

  let { props: props_vi } = viewItem ?? {}

  // if the props for the viewItem do not exist, get them from the global viewItem
  if (!props_vi || Object.keys(props_vi).length === 0) {
    if (props_vig) {
      props_vi = props_vig
    }
  }

  // if the props for the viewItem do not exist, get them from the viewListData
  if (viewListData && (!props_vi)) {
    props_vi = settingsHelpers.createPropsFromData(viewListData)
  }

  if (_.isArray(props_vi)) {
    props_vi.forEach(sp => {
      sp.show = true
    })
  }
  return props_vi
}

export const ammendIcons = (props_vig, props_viewItem, aps_viewItems, defaultIconColor, showDefaultIconsInDisplay, showDefaultIconsInDisplayIfNull) => {

  const setIcon = (pvi, icon) => {
    let allow = false
    if (icon && icon !== 'file alternative') {
      if (showDefaultIconsInDisplay) {
        allow = true
      } else if (showDefaultIconsInDisplayIfNull) {
        allow = pvi.display.icon ? false : true
      }
      if (allow) {
        pvi.display.icon = icon
        pvi.display.defaultIconColor = defaultIconColor
      }
    }
  }

  if (props_viewItem && (showDefaultIconsInDisplay || showDefaultIconsInDisplayIfNull)) {
    Object.keys(props_viewItem).forEach(propKey => {
      const pvi = props_viewItem[propKey]
      if (pvi && pvi.tagged && pvi.display) {
        const prop_vig = props_vig ? props_vig[propKey] : {}
        const { display: display_prop } = prop_vig ?? {}
        const { icon: icon_prop } = display_prop ?? {}

        const vi_g = aps_viewItems ? aps_viewItems[propKey] : {}
        const { display: display_vi_g } = vi_g ?? {}
        const { defaultIcon } = display_vi_g ?? {}

        const _icon = icon_prop ? icon_prop : defaultIcon

        setIcon(pvi, _icon)

      }
    })
  }
}
